export const showMemberExplanation = () => {
  window.dispatchEvent(new CustomEvent("appshell:member-explanation-show"))
}

export const navigateToCart = () => {
  window.dispatchEvent(new CustomEvent("appshell:navigate-to-cart"))
}

export const showCart = (detail: {
  addMoreCallback: () => void
  goToCartDataLayerEvent: () => void
}) => {
  window.dispatchEvent(new CustomEvent("appshell:cart-show", { detail }))
}
